import { brandDiffConfig } from '@/brandConfig/diff';
import welcomeModel from '@/components/Welcome';
import { moduleRouter } from '@/hooks/auth/menuType';
import { homeRouter, RouterType } from '@/router';
import { Modal } from 'ant-design-vue';
import { cloneDeep } from 'lodash-es';
import { getMenuAuthority } from '../../api/authority';
import { loginUrl } from '../../api/fetch';
import { AuthItem, IsFirstLoginEnum, IsFirstUseEnum, MENU_LIST } from '../../type/auth';
import { MenuItem } from '../../type/menu';
import { menuRouter } from './menuType';
import useMenuPermission from './useMenuPermission';

export const ISWELCOME = 'isWelcome';
interface DealMenu {
  url: string;
  menu_name: string;
}
/**
 * 深度遍历
 */
const depthTraverse = (root: AuthItem[], callback: (param: AuthItem) => void) => {
  const nodeStack: AuthItem[] = root; // 栈
  while (nodeStack.length) {
    const curNode = nodeStack.pop();
    if (!curNode) break;
    callback(curNode);
    const childNodes = curNode.child_menu || [];
    if (childNodes?.length) {
      // 子节点入栈
      childNodes.forEach((child) => {
        nodeStack.push(child);
      });
    }
  }
};
/**
 * 获取菜单和路由列表
 */
const getAuthList = async (menuRouter: any, homeRouter: any) => {
  // 权限原始数据
  let originAuthList: AuthItem[] = [];
  // 有权限的路径列表
  const urlList: string[] = ['/'];
  // 重新组装url
  const dealUrlList: Array<DealMenu> = [];
  // 有权限的路由列表
  let routerList: Array<any> = [];
  // 获取用户权限列表
  let menuList: Array<MenuItem> = [];

  const res = await getMenuAuthority();
  if (res.code === 0) {
    originAuthList = res.data?.detail_menus;
    const showWelcome = res.data?.is_first_login;
    const isFirstUse = res.data?.is_first_use;
    // 黑名单是否展示详情页小眼睛，1展示，0不展示
    const showPhoneEye = res.data?.show_phone_eye;
    sessionStorage.setItem('showPhoneEye', String(showPhoneEye));
    if (showWelcome === IsFirstLoginEnum.SHOW) {
      // if (true) {
      localStorage.setItem(ISWELCOME, 'true');
      welcomeModel();
    }
    depthTraverse(cloneDeep(originAuthList), (param) => {
      param.url && dealUrlList.push({ url: param.url, menu_name: param.menu_name });

      // param.url && urlList.push(param.url);
    });

    // 处理路由权限问题
    dealUrlList.forEach((item) => {
      urlList.push(item.url);
    });

    // menuList = menuAuthority(menuRouter, urlList);
    menuList = dealMenuAuthority(menuRouter, dealUrlList);
    localStorage.setItem(MENU_LIST, JSON.stringify(menuList));

    routerList = getRoutesAuth(homeRouter, urlList);

    [menuList, routerList] = useMenuPermission(menuList, routerList, res.data.show_myclass_menu);

    const hasMyClassModule = menuList.some((item) => item.name === 'myClass');
    const hasNewMyClassModule = menuList.some((item) => item.name === 'newMyClass');
    // 当使用过新体验模式之后，每次进入重定向到新体验模式
    if (brandDiffConfig.redirectToNewClass && hasNewMyClassModule) {
      // 只有希望学走此逻辑，素养不走（目前素养还不支持新体验模式，之后支持后可删除该判断）
      if (isFirstUse === IsFirstUseEnum.UN_FIRST_USE || (isFirstUse === IsFirstUseEnum.FIRST_USE && !hasMyClassModule)) {
        routerList.forEach((router) => {
          if (router.name === 'home' && router.path === '/') {
            router.redirect = '/newMyClass';
          }
        });
      }
    }
  } else {
    if (res.code === 10500) {
      // TODO: 停服下线后删除该代码 为停服服务
      return {
        routerList
      };
    }
    Modal.info({
      title: '温馨提示',
      content: res.msg,
      onOk: () => {
        localStorage.removeItem('userInfo');
        localStorage.removeItem('hasLogin');
        localStorage.removeItem('Teacher-Desk-X-BRAND'); // 清空选中的品牌
        window.location.href = 'https://sso.saash.vdyoo.com/sso/logout?path=' + loginUrl;
      }
    });
  }
  return {
    menuList,
    routerList,
    originAuthList
  };
};

/**
 * 获取菜单权限列表
 * @param {object} option 请求菜单权限接口参数
 * @param {Array} menuRouter 总权限列表
 * @return {Array} 有权限的菜单列表
 */
const menuAuthority = (menuRouter: Array<MenuItem>, urlList: any): MenuItem[] => {
  // 过滤 menuRouter 返回有权限的菜单
  menuRouter = menuRouter.filter((child) => {
    const { children } = child;
    if (children?.length) {
      child.children = children.filter((item: MenuItem) => urlList.includes(item.path));
    }
    return urlList.includes(child.path);
  });
  return menuRouter;
};

/**
 * @description: 获取菜单权限列表（由接口获取）
 * @param {*} menuRouter
 * @param {*} dealUrlList
 * @returns {*}
 */
const dealMenuAuthority = (menuRouter: Array<MenuItem>, dealUrlList: Array<DealMenu> = []) => {
  const dataMap = new Map(dealUrlList.map((item) => [item.url, item]));

  menuRouter = menuRouter
    .filter((child) => {
      const { children } = child;
      if (children?.length) {
        child.children = children
          .filter((item: MenuItem) => dataMap.has(item.path))
          .map((cItem) => {
            cItem.chname = dataMap.get(cItem.path)?.menu_name || '';
            return cItem;
          });
      }
      return dataMap.has(child.path);
    })
    .map((cItem) => {
      cItem.chname = dataMap.get(cItem.path)?.menu_name || '';
      return cItem;
    });
  // 数据看板，动态路由和页面
  menuRouter.forEach((menu) => {
    if (menu.name === 'dataBoard') {
      for (let i = 0; i < dealUrlList.length; i++) {
        if (dealUrlList[i].url.includes('/dataBoard/')) {
          const chname = dealUrlList[i].menu_name || '';
          const name = dealUrlList[i].url.split('/dataBoard/')[1] || '';
          const path = dealUrlList[i].url.includes('?') ? dealUrlList[i].url.split('?')[0] : dealUrlList[i].url;
          // url上边可能会携带query参数
          const query = dealUrlList[i].url;
          menu.children?.push({
            chname,
            name,
            path,
            query
          });
        }
      }
    }
  });
  return menuRouter;
};

/**
 * 动态添加路由
 * @param {object} option 请求菜单权限接口参数
 * @param {Array} menuRouter 总权限列表
 * @return {Array} 有权限的菜单列表
 */
const getRoutesAuth = (homeRouter: RouterType[], urlList: any, parentPath?: string) => {
  let result: RouterType[] = [];
  // 添加路由
  result = homeRouter.filter((child: any) => {
    const { children, meta } = child;
    if (children?.length && meta?.auth) {
      // child.children = getRoutesAuth(children, urlList);
      child.children = getRoutesAuth(children, urlList, child.path);
    }
    if (parentPath && moduleRouter[parentPath] && moduleRouter[parentPath].includes(child.name)) {
      return true;
    }
    return urlList.includes(child.path);
  });
  return result;
};
export const useMenuProvide = () => {
  return getAuthList(menuRouter, homeRouter);
};
